/**
 * Normalizes an email for case-insensitive comparison and storage:
 * trims surrounding whitespace and lowercases it.
 * @param email the raw email (may be undefined)
 * @returns the trimmed, lowercased email, or '' when input is empty/undefined
 */
export function normalizeEmail(email?: string): string {
  return email?.trim().toLowerCase() || '';
}
